<template>
  <div class="container">
    <Navigation />

    <h1 class="title">PAINTINGS#</h1>

    <!--
               <a class="tile is-child" href="/img/paintings/kpon.png"><img src="/img/paintings/kpon.png"></a>
               <a class="tile is-child" href="/img/paintings/stainless.jpeg"><img src="/img/paintings/stainless.jpeg"></a>
               <a class="tile is-child" href="/img/paintings/medium/xyyy-m.jpg"><img src="/img/paintings/xyyy.jpg"></a>
               <a class="tile is-child" href="/img/paintings/medium/toldom-m.jpg"><img src="/img/paintings/toldom.jpg"></a>
    -->

    <div class="tile is-ancestor">
      <div class="tile is-vertical is-parent is-4">
            <a class="tile is-child" href="/img/paintings/bliss.jpg"><img src="/img/paintings/bliss.jpg"></a>
          <a class="tile is-child" href="/img/paintings/medium/keypill-m.jpg"><img src="/img/paintings/medium/keypill-m.jpg"></a>
          <a class="tile is-child" href="/img/paintings/medium/dia-1-m.jpg"><img src="/img/paintings/medium/dia-1-m.jpg"></a>
          <a class="tile is-child" href="/img/paintings/medium/suicid-m.jpg"><img src="/img/paintings/medium/suicid-m.jpg"></a>
      </div>
      <div class="tile is-vertical is-parent">
        <a class="tile is-child is-12" href="/img/paintings/medium/bc-m.png"><img src="/img/paintings/medium/bc-m.png"></a>
        <div class="tile is-parent">
          <div class="tile is-vertical is-parent is-6">
            <a class="tile is-child" href="/img/paintings/medium/ccat-m.jpg"><img src="/img/paintings/medium/ccat-m.jpg"></a>
            <a class="tile is-child" href="/img/paintings/medium/ddc-m.jpeg"><img src="/img/paintings/medium/ddc-m.jpeg"></a>
			  <a class="tile is-child" href="/img/paintings/medium/racc-m.jpg"><img src="/img/paintings/medium/racc-m.jpg"></a>
          </div>
          <div class="tile is-vertical is-parent is-6">
            <a class="tile is-child" href="/img/paintings/medium/alco-m.jpg"><img src="/img/paintings/medium/alco-m.jpg"></a>
            <a class="tile is-child" href="/img/paintings/medium/dia-2-m.jpg"><img src="/img/paintings/medium/dia-2-m.jpg"></a>
            <a class="tile is-child" href="/img/paintings/medium/billy-m.jpg"><img src="/img/paintings/medium/billy-m.jpg"></a>
          </div>
        </div>
      </div>
    </div>
    <div>
      <a href="/img/paintings/kpon.png" rel="gallery"><img src="/img/paintings/kpon.png" style="width:100%;"></a>
      <a href="/img/paintings/stainless.jpeg" rel="gallery"><img src="/img/paintings/stainless.jpeg" style="width:100%;"></a>
      <a href="/img/paintings/medium/xyyy-m.jpg" rel="gallery"><img src="/img/paintings/xyyy.jpg"></a>
      <a href="/img/paintings/medium/toldom-m.jpg" rel="gallery"><img src="/img/paintings/toldom.jpg"></a>
    </div>
</div>
</template>
<script>

import Navigation from '@/components/Navigation'

export default {
  name: 'Paintings',
  components: {
    Navigation
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tile {
  align-items: flex-start;
}
</style>
